/* eslint-disable no-unused-vars */
import { DoubleLeftIcon, LeftIcon } from '@/assets/icons';
import { useMemo } from 'react';

import { PaginationProps } from 'antd';
import { getPagePagination } from 'utils';

import clsx from 'clsx';

import Button from '../button';

export const PrevIcon = (
	props: PaginationProps & { pageSizeLocal?: number; totalLocal?: number }
) => {
	if (!props) return null;
	const { current = 1, pageSizeLocal, totalLocal } = props;

	const pageSize = pageSizeLocal ?? props.pageSize ?? 10;

	const total = useMemo(
		() => getPagePagination(totalLocal ?? props.total, pageSize),
		[totalLocal, props.total, pageSize]
	);

	return (
		<div
			className="min-h-full center gap-x-1 max-h-6"
			onClick={(e) => e?.stopPropagation?.()}
			title=""
		>
			<Button
				title="Previous"
				className={clsx(
					'!gap-0 h-6 min-w-6 p-0 text-font2 border-seaShell disabled:!cursor-not-allowed xl:rounded',
					current === 1 && '!text-greyGoose !border-seaShell'
				)}
				disabled={current === 1}
				onClick={(e) => {
					e?.stopPropagation?.();
					props.onChange?.(current - 1, pageSize);
				}}
				size="small"
				icon={<LeftIcon />}
			/>

			<Button
				title="First"
				className={clsx(
					'!gap-0 h-6 min-w-6 p-0 text-font2 border-seaShell disabled:!cursor-not-allowed xl:rounded',
					(total === 0 || total <= 2) && '!hidden',
					current === 1 && '!text-greyGoose !border-seaShell'
				)}
				disabled={current === 1}
				onClick={(e) => {
					e?.stopPropagation?.();
					props.onChange?.(1, pageSize);
				}}
				size="small"
				icon={<DoubleLeftIcon />}
			/>
		</div>
	);
};

export const NextIcon = (
	props: PaginationProps & { pageSizeLocal?: number; totalLocal?: number }
) => {
	if (!props) return null;
	const { current = 1, pageSizeLocal, totalLocal } = props;

	const pageSize = pageSizeLocal ?? props.pageSize ?? 10;

	const total = useMemo(
		() => getPagePagination(totalLocal ?? props.total, pageSize),
		[totalLocal, props.total, pageSize]
	);

	return (
		<div
			className="min-h-full center gap-x-1 max-h-6 ml-1"
			onClick={(e) => e?.stopPropagation?.()}
			title=""
		>
			<Button
				title="Last"
				className={clsx(
					'!gap-0 h-6 min-w-6 p-0 text-font2 border-seaShell disabled:!cursor-not-allowed xl:rounded',
					(total === 0 || total <= 2) && '!hidden',
					current === total && '!text-greyGoose !border-seaShell'
				)}
				classNames={{ icon: 'rotate-180' }}
				disabled={current === total}
				onClick={(e) => {
					e?.stopPropagation?.();
					props.onChange?.(total, pageSize);
				}}
				size="small"
				icon={<DoubleLeftIcon />}
			/>

			<Button
				title="Next"
				className={clsx(
					'!gap-0 h-6 min-w-6 p-0 text-font2 border-seaShell disabled:!cursor-not-allowed xl:rounded',
					current === total && '!text-greyGoose !border-seaShell'
				)}
				classNames={{ icon: 'rotate-180' }}
				disabled={current === total}
				onClick={(e) => {
					e?.stopPropagation?.();
					props.onChange?.(current + 1, pageSize);
				}}
				size="small"
				icon={<LeftIcon />}
			/>
		</div>
	);
};
